import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, MessageSquareHeart, CheckCircle2 } from 'lucide-react';
import { feedbackApi } from '../../api/feedbackApi';

export function Feedback() {
  const nav = useNavigate();
  const [text, setText] = useState('');
  const send = useMutation({ mutationFn: (t: string) => feedbackApi.send(t) });

  return (
    <div className="rf-detail">
      <div className="rf-topbar">
        <button className="rf-back" onClick={() => nav(-1)}><ChevronLeft /> Назад</button>
        <div className="rf-topbar-title">Оставить отзыв</div>
      </div>

      <div className="rf-detail-scroll">
        {send.isSuccess ? (
          <div className="rf-card" style={{ padding: 20, textAlign: 'center' }}>
            <CheckCircle2 size={40} color="var(--rf-accent, #2e86ff)" style={{ margin: '0 auto 12px' }} />
            <div style={{ fontSize: 17, fontWeight: 600, marginBottom: 6 }}>Спасибо за отзыв!</div>
            <div style={{ color: 'var(--rf-text-2, #96a0b5)', fontSize: 14, lineHeight: 1.5 }}>
              Мы читаем каждое сообщение — это помогает сделать продукт лучше.
            </div>
            <button
              onClick={() => nav(-1)}
              style={{ marginTop: 18, background: 'var(--rf-accent-grad, linear-gradient(135deg,#2e86ff,#7c5cff))', color: '#fff', border: 'none', padding: '13px 24px', borderRadius: 14, fontSize: 15, fontWeight: 600, width: '100%', cursor: 'pointer' }}
            >
              Готово
            </button>
          </div>
        ) : (
          <div className="rf-card" style={{ padding: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <MessageSquareHeart size={22} color="var(--rf-accent, #2e86ff)" />
              <b style={{ fontSize: 16 }}>Расскажите, что улучшить</b>
            </div>
            <p style={{ color: 'var(--rf-text-2, #96a0b5)', fontSize: 14, lineHeight: 1.5, marginBottom: 14 }}>
              Идеи, баги, пожелания — всё пойдёт в дело. Отзыв уйдёт напрямую команде.
            </p>
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Ваш отзыв…"
              rows={6}
              style={{
                width: '100%', boxSizing: 'border-box', padding: 14, borderRadius: 12, resize: 'vertical',
                background: 'var(--rf-surface, rgba(255,255,255,0.06))', border: '1px solid var(--rf-border, rgba(255,255,255,0.14))',
                color: 'var(--rf-text, #e8ecf4)', fontSize: 15, outline: 'none', lineHeight: 1.5,
              }}
            />
            {send.isError && <div style={{ color: 'var(--rf-danger, #ff6b6b)', fontSize: 14, marginTop: 10 }}>Не удалось отправить. Попробуйте ещё раз.</div>}
            <button
              disabled={!text.trim() || send.isPending}
              onClick={() => send.mutate(text.trim())}
              style={{
                marginTop: 14, width: '100%', padding: '14px', borderRadius: 14, border: 'none', fontSize: 16, fontWeight: 600,
                background: 'var(--rf-accent-grad, linear-gradient(135deg,#2e86ff,#7c5cff))', color: '#fff',
                cursor: (!text.trim() || send.isPending) ? 'not-allowed' : 'pointer',
                opacity: (!text.trim() || send.isPending) ? 0.5 : 1,
                boxShadow: 'var(--rf-glow, 0 6px 20px rgba(46,134,255,0.35))',
              }}
            >
              {send.isPending ? 'Отправка…' : 'Отправить отзыв'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Feedback;
